
export class AssingPropietarioTitularRequest {

  public idPropiedadPropietario!: number;
  public idPropiedad!: number;
  public idPropietario!: number;
  public motivo: string = ""
}
